<div class="flex items-center p-4 pb-2 border-b border-gray-200">
    <mat-icon class="text-orange-500 mr-2 text-2xl">warning_amber</mat-icon>
    <h2 class="font-semibold text-lg text-gray-800 m-0">
        Duplicate Question Detected
    </h2>
</div>

<mat-dialog-content class="p-4 max-h-[60vh] overflow-auto">
    <p class="text-gray-600 bg-orange-50 p-3 rounded-md text-sm mb-5">
        {{ data?.errorMessage }}
    </p>

    <div *ngFor="let lang of languages" class="mb-4">
        <h4 class="text-sm my-2 text-gray-800">
            Language:
            <span class="font-medium text-indigo-600">{{
                lang | titlecase
            }}</span>
        </h4>

        <div class="flex flex-col gap-3">
            <mat-card
                class="p-3 rounded-xl bg-gray-50 border border-gray-200 shadow-sm"
                *ngFor="let item of data?.meta?.duplicate_questions[lang]"
            >
                <div
                    class="font-semibold text-sm mb-1.5 text-gray-900"
                    [innerHTML]="item.content[lang]"
                ></div>
                <div class="text-xs text-gray-500 flex justify-between">
                    <span>ID: {{ item.duplicate_question_id }}</span>
                    <span>Similarity: {{ item.similarityPercentage }}%</span>
                </div>
            </mat-card>
        </div>
    </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
    <button mat-stroked-button color="warn" (click)="close()">Close</button>
</mat-dialog-actions>
